export const ERROR_DEFAULT_TEXT =
  'У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, другие статьи, а позже попробуйте еще раз!';
export const REVIEW_TITLE = 'Оставьте комментарий к статье';
export const REVIEW_BTN_TEXT = 'Оставить комментарий';
export const REVIEW_ERROR_TEXT = 'Напишите комментарий';
export const REVIEW_PLACEHOLDER = 'Место для ввода комментария';
export const REVIEW_MODERATE_TEXT = 'Комментарий принят и появится на сайте после модерации!';



// WEBPACK FOOTER //
// ./src/pages/blog/article/const.ts